import { QuoteStatus } from '@/api/apis/case';
import { AirQuote } from '@/api/apis/quote';

export const parseCurrencyStringUS = (currencyString: string) => {
  const normalizedNumber = currencyString.replace(/[^0-9.]/g, '');
  return Number.isNaN(parseFloat(normalizedNumber)) ? 0 : parseFloat(normalizedNumber);
};

export const getQuoteSuffixByStatus = (quoteStatus?: QuoteStatus) => {
  switch (quoteStatus) {
    case QuoteStatus.Rejected:
      return '(Rejected)';
    case QuoteStatus.Recalled:
      return '(Recalled)';
    default:
      return '';
  }
};

export const getCalculatedAirPriceInCents = (airQuote: AirQuote): number =>
  airQuote.initPriceInCents > 0 ? airQuote.initPriceInCents : airQuote.finalPriceInCents;

export const shouldShowLightsSirensBanner = (q?: { status?: QuoteStatus }) => {
  return (
    !!q?.status &&
    [
      QuoteStatus.Created,
      QuoteStatus.ApprovedInternally,
      QuoteStatus.SentToTXCenter,
      QuoteStatus.Approved,
      QuoteStatus.Rejected,
      QuoteStatus.Recalled,
    ].includes(q.status)
  );
};
